// 이름류 입력 검사 한 벌 — 가입·시공사 만들기·출시 알림·설정 상호·계약 설정 대표자·운영자 시연 상호가 같이 쓴다.

import { cleanName, hasControlChars, hasVisibleChars, looksLikeUrl } from "./control-chars";
import { objectJosa, subjectJosa, topicJosa } from "./josa";

export type NameParsed = { ok: true; value: string } | { ok: false; error: string };

export interface NameRule {
  label: string;
  max: number;
  url: boolean;
}

// 사람 이름 상한(코드포인트) — 가입·담당자·계약 대표자 · onboarding/rules 가 다시 내보낸다.
export const PERSON_NAME_MAX = 40;

export const nameInvalidMessage = (label: string): string => `${label}에는 줄바꿈·보이지 않는 문자나 링크·주소를 넣을 수 없습니다`;

// 제어문자 오류 문구 — 주소 꼴도 막는 규칙이면 링크·주소까지 적는다.
export const controlCharsMessage = (rule: NameRule): string => (rule.url ? nameInvalidMessage(rule.label) : `${rule.label}에는 줄바꿈·보이지 않는 문자를 넣을 수 없습니다`);

// 원문 상한(정리 후 상한의 10배 코드포인트) — UTF-16 길이가 그 2배를 넘으면 코드포인트도 넘으므로 펼치지 않고 판정한다.
export const isRawNameTooLong = (value: string, max: number): boolean => value.length > max * 20 || [...value].length > max * 10;

// 원문 상한(정리 후 상한의 10배) → cleanName → 빈 값·보이는 글자 → 정리 후 상한(코드포인트 — DB char_length 와 같은 단위) → 제어문자·주소 꼴(url false 면 주소 꼴은 허용).
export const parseNameText = (raw: unknown, rule: NameRule): NameParsed => {
  const value = typeof raw === "string" ? raw : "";
  if (isRawNameTooLong(value, rule.max)) return { ok: false, error: `${rule.label}${subjectJosa(rule.label)} 너무 깁니다` };
  const name = cleanName(value);
  if (name === "" || !hasVisibleChars(name)) return { ok: false, error: `${rule.label}${objectJosa(rule.label)} 넣어 주세요` };
  if ([...name].length > rule.max) return { ok: false, error: `${rule.label}${topicJosa(rule.label)} ${rule.max}자까지입니다` };
  if (hasControlChars(name)) return { ok: false, error: controlCharsMessage(rule) };
  if (rule.url && looksLikeUrl(name)) return { ok: false, error: nameInvalidMessage(rule.label) };
  return { ok: true, value: name };
};

// 이름을 적었다고 볼지 — 정리 후 보이는 글자가 있거나 원문이 상한을 넘으면(검사로 보내 「너무 깁니다」) · 보이지 않는 글자뿐이면 안 적은 것.
export const isNameGiven = (raw: unknown, max: number): boolean => {
  const value = typeof raw === "string" ? raw : "";
  return value.length > max * 20 || hasVisibleChars(cleanName(value));
};

// 선택 칸 이름(설정 상호·계약 대표자) — 안 적었으면 빈 값 · 적었으면 parseNameText.
export const parseOptionalNameText = (raw: unknown, rule: NameRule): NameParsed =>
  isNameGiven(raw, rule.max) ? parseNameText(raw, rule) : { ok: true, value: "" };
